
<template>
  <!-- Informazioni della campagna selezionata -->
  <div>
    <!-- Descrizione, stato e modifica della campagna -->
    <b-row class="mt-3 align-items-center">
      <b-col cols="12" md="8" class="d-flex align-items-center flex-wrap">
        <span class="h4 mb-0">
          {{ campagna.descrizione }}
        </span>
        <!-- Colore del badge in base allo stato della campagna -->
        <b-badge
          :variant="{
            NUOVO: 'secondary',
            PUBBLICATO: 'success',
            CHIUSO: 'primary',
            ANNULLATO: 'danger'
          }[campagna.stato] || 'secondary'"
          class="ml-2 mr-5"
        >
          {{ campagna.stato }}
        </b-badge>
        <!-- Pubblicazione della campagna -->
        <b-button
          v-if="campagna.stato === 'NUOVO'"
          size="sm"
          variant="outline-success"
          class="mr-2"
          @click="$emit('cambio-stato', 'PUBBLICATO')"
        >
          <b-icon icon="check-circle" class="mr-1" />
          Pubblica
        </b-button>
        <!-- Chiusura della campagna -->
        <b-button
          v-if="campagna.stato === 'PUBBLICATO'"
          size="sm"
          variant="outline-primary"
          class="mr-2"
          @click="$emit('cambio-stato', 'CHIUSO')"
        >
          <b-icon icon="lock" class="mr-1" />
          Chiudi campagna
        </b-button>
        <!-- Ripubblicazione della campagna -->
        <b-button
          v-if="campagna.stato === 'ANNULLATO'"
          size="sm"
          variant="outline-success"
          class="mr-2"
          @click="$emit('cambio-stato', 'PUBBLICATO')"
        >
          <b-icon icon="arrow-repeat" class="mr-1" />
          Ripubblica
        </b-button>
      </b-col>
    </b-row>

    <!-- Informazioni della campagna organizzate in quattro card -->
    <b-row class="mt-3">
      <b-col cols="12" md="8">
        <b-row>
          <!-- Data inizio -->
          <b-col cols="12" md="6" class="mb-3">
            <b-card bg-variant="light" class="cp-info-card">
              <b-icon icon="calendar-event" class="cp-info-icona" />
              <span class="cp-info-label">Data inizio</span>
              <strong class="cp-info-valore">
                {{ campagna.data_inizio | toitadate }}
              </strong>
            </b-card>
          </b-col>

          <!-- Data fine -->
          <b-col cols="12" md="6" class="mb-3">
            <b-card bg-variant="light" class="cp-info-card">
              <b-icon icon="calendar-check" class="cp-info-icona" />
              <span class="cp-info-label">Data fine</span>
              <strong class="cp-info-valore">
                {{ campagna.data_fine | toitadate }}
              </strong>
            </b-card>
          </b-col>
          <!-- Scadenza risposta -->
          <b-col cols="12" md="6" class="mb-3">
            <b-card bg-variant="light" class="cp-info-card">
              <b-icon icon="clock-history" class="cp-info-icona" />
              <span class="cp-info-label">Scadenza risposta</span>
              <strong class="cp-info-valore">
                {{ campagna.data_scadenza_risposta | toitadate }}
              </strong>
            </b-card>
          </b-col>
          <!-- Maggiorazione Welfare -->
          <b-col cols="12" md="6" class="mb-3">
            <b-card bg-variant="light" class="cp-info-card">
              <b-icon icon="graph-up" class="cp-info-icona" />
              <span class="cp-info-label">Maggiorazione Welfare</span>
              <strong class="cp-info-valore">
                {{ campagna.percentuale_maggiorazione }}%
              </strong>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "CPCampagnaHeader",

  props: {
    // Campagna selezionata e gestita dal componente principale.
    campagna: { type: Object, required: true },
    // Indica se è in corso l'esportazione Excel.
    esportazione_in_corso: { type: Boolean, default: false }
  }
};
</script>
<style scoped>
/* Card delle informazioni della campagna */
.cp-info-card {
  border-radius: 10px;
  border: none;
}

/* Contenuto della card disposto su una sola riga */
.cp-info-card ::v-deep .card-body {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  min-height: 64px;
}

/* Icona descrittiva */
.cp-info-icona {
  font-size: 24px;
  color: #6c757d;
  flex-shrink: 0;
}

/* Titolo dell'informazione */
.cp-info-label {
  font-size: 15px;
  color: #495057;
}

/* Valore allineato a destra */
.cp-info-valore {
  margin-left: auto;
  font-size: 17px;
  color: #212529;
  white-space: nowrap;
}
</style>